import React, { Fragment } from "react";
import * as CONSTANT from "constants/text.js";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import AxiosConfig from "axiosConfig";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import TextArea from "components/General/Form/TextArea";
import CustomSelect from "components/General/Form/CustomSelect";
import CustomInput from "components/General/Form/CustomInput";
import UploadImage from "components/General/Form/UploadImage";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import TextTheme from "components/General/Text/TextTheme";
import GroupDefault from "site_media/images/groups_default.png";
import imageCompression from "browser-image-compression";
import CustomVisibilityRadioButton from "components/General/Form/CustomVisibilityRadioButton";
import "./GroupForm.css";
import GroupProjectCategoryGrid from "../../../../components/Tribe/Groups/GroupProjectCategoryGrid";

class GroupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadPhoto: "",
      displayPhoto: "",
      uploadCoverPhoto: "",
      displayCoverPhoto: "",
      hasGroupName: true,
      isEmailValid: true,
      groupName: "",
      aboutUs: "",
      groupMission: "",
      projectCat: [],
      projectInterest: [],
      ourFavoriteCauses: "",
      phone: "",
      email: "",
      street: "",
      city: "",
      stateUS: "",
      zip: "",
      website: "",
      visibility: "PRIVATE",
      isPhoneValid: true,
      groupId: this.props.match.params.groupId,
      profilePicError: "",
      coverPicError: "",
    };

    // function bindings
    this.handleImageOnChange = this.handleImageOnChange.bind(this);
    this.handleCoverImageOnChange = this.handleCoverImageOnChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    ProfileHelper.getCategory(this);
    this.fetchGroupProfile(this);
  }

  // Following methods are event handlers for an input change

  // On image change
  fetchGroupProfile(obj) {
    AxiosConfig.get(`groups/details/${this.state.groupId}/`).then(function (
      response
    ) {
      if (response) {
        obj.setState({
          groupName: response.data.name,
          phone: response.data.contact.split("__")[0],
          email: response.data.contact.split("__")[1].trim(),
          website: response.data.website,
          street: response.data.location.split("__")[0].trim(),
          city: response.data.location.split("__")[1].trim(),
          stateUS: response.data.location.split("__")[2].trim(),
          zip: response.data.location.split("__")[3].trim(),
          aboutUs: response.data.description,
          groupMission: response.data.mission,
          projectInterest: response.data.project_interest,
          ourFavoriteCauses: response.data.causes,
          visibility: response.data.visibility,
          displayCoverPhoto: response.data.cover_pic,
          displayPhoto: response.data.group_pic,
        });
      }
    });
  }
  handleImageOnChange(e) {
    const imageFile = e.target.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (imageFile) {
      const fileSize = imageFile.size / 1024;
      if (fileSize > 1000) {
        imageCompression(imageFile, options)
          .then((compressedFile) => {
            this.setState({
              profilePicError:
                "Uploaded image is too big in size. Image has been compressed.",
              displayPhoto: URL.createObjectURL(compressedFile),
              uploadPhoto: compressedFile,
            });
          })
          .catch((error) => {
            this.setState({
              profilePicError: "Uploaded image is too big in size.",
            });
          });
      } else {
        this.setState({
          displayPhoto: URL.createObjectURL(imageFile),
          uploadPhoto: imageFile,
          profilePicError: "",
        });
      }
    }
  }

  /*
   * On cover image change
   */
  handleCoverImageOnChange(e) {
    const imageFile = e.target.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (imageFile) {
      const fileSize = imageFile.size / 1024;
      if (fileSize > 1000) {
        imageCompression(imageFile, options)
          .then((compressedFile) => {
            this.setState({
              coverPicError:
                "Uploaded image is too big in size. Image has been compressed.",
              displayCoverPhoto: URL.createObjectURL(compressedFile),
              uploadCoverPhoto: compressedFile,
            });
          })
          .catch((error) => {
            this.setState({
              coverPicError: "Uploaded image is too big in size.",
            });
          });
      } else {
        this.setState({
          displayCoverPhoto: URL.createObjectURL(imageFile),
          uploadCoverPhoto: imageFile,
          coverPicError: "",
        });
      }

      // this.setState({
      //   displayCoverPhoto: URL.createObjectURL(e.target.files[0]),
      //   uploadCoverPhoto: e.target.files[0],
      // });
    }
  }

  /*
   * On data change.
   */
  handleDataChange(e) {
    if (e.target.name === "groupName" && !this.state.groupName) {
      this.setState({ hasGroupName: true });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "email" && !this.state.isEmailValid)
      this.setState({ isEmailValid: true });

    if (e.target.name === "phone" && !this.state.isPhoneValid)
      this.setState({ isPhoneValid: true });
  }
  //End of input onChange handlers.

  // Validate certain fields in the group form
  validateForm() {
    // valid flag
    let valid = true;

    // check that the group name is not empty.
    if (!this.state.groupName) {
      this.setState({ hasGroupName: false });
      valid = false;
    }

    /**
     *  check that the email is valid.
     *  code copied from "components/Project/FriendsSearchHelper/FriendsSearchHelper.js" lines 173-176
     */
    if (
      (this.state.email.length > 0 &&
        this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ===
          null) ||
      this.state.email == ""
    ) {
      this.setState({ isEmailValid: false });
      valid = false;
    }
    const mobileRegex = /^\d{10}$/;
    if (
      this.state.phone == "" ||
      this.state.phone.match(mobileRegex) === null
    ) {
      this.setState({ isPhoneValid: false });
      valid = false;
    }

    return valid;
  }

  //POST method for group form.
  onSubmit(e) {
    // check that the form is valid.
    if (!this.validateForm()) {
      if (window.innerWidth > 640)
        window.scrollTo({ top: 650, behavior: "smooth" });
      else window.scrollTo({ top: 350, behavior: "smooth" });
      return;
    }

    // store this object
    let obj = this;

    // make a new form and add any filled in fields
    let formData = new FormData();
    formData.append("name", this.state.groupName);

    // if there is a group_pic
    if (this.state.uploadPhoto) {
      formData.append(
        "group_pic",
        this.state.uploadPhoto,
        this.state.uploadPhoto.name
      );
    }

    // if there is a cover_pic
    if (this.state.uploadCoverPhoto) {
      formData.append(
        "cover_pic",
        this.state.uploadCoverPhoto,
        this.state.uploadCoverPhoto.name
      );
    }

    // if about us is filled in
    if (this.state.aboutUs) formData.append("description", this.state.aboutUs);
    // if any of the address fields are filled in
    if (
      this.state.stateUS ||
      this.state.street ||
      this.state.zip ||
      this.state.city
    )
      formData.append(
        "location",
        this.state.street +
          "__" +
          this.state.city +
          "__" +
          this.state.stateUS +
          "__" +
          this.state.zip
      );

    // if any of the contact fields are filled in
    if (this.state.phone || this.state.email)
      formData.append("contact", this.state.phone + "__ " + this.state.email);

    //Group Website
    if (this.state.website) formData.append("website", this.state.website);

    //Group's Mission
    if (this.state.groupMission)
      formData.append("mission", this.state.groupMission);

    //We Support
    if (this.state.projectInterest) {
      this.state.projectInterest.forEach((item) => {
        formData.append("project_interest", item);
      });
    }

    //Favorite Causes
    if (this.state.ourFavoriteCauses)
      formData.append("causes", this.state.ourFavoriteCauses);

    // Visibility starts off as checked so it will always be a value. Add to the form
    formData.append("visibility", this.state.visibility);

    if (this.state.groupId != undefined) {
      formData.append("groupId", this.state.groupId);
      // AxiosConfig.put(`/groups/details/${this.state.groupId}/`)
      AxiosConfig.put(`/groups/details/${this.state.groupId}/`, formData, {
        headers: { "content-type": "multipart/form-data" },
      }).then(function (response) {
        obj.props.history.replace("/groups");
      });
    } else {
      AxiosConfig.post("groups/", formData, {
        headers: { "content-type": "multipart/form-data" },
      }).then(function (res) {
        if (res.status === 201) {
          //route back to groups page.
          obj.props.history.replace("/groups");
        }
      });
    }
  }

  /*
   * Render method
   */
  render() {
    return (
      <div className="header_main">
        <div className="page_main">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="page_details_main">
            <div className="page_details_content_main">
              {this.state.groupId == undefined ? (
                <div className="textHeader mb-15">
                  {CONSTANT.START_NEW_GROUP}
                </div>
              ) : null}
              <div className="the_photos" style={{ display: "grid" }}>
                <div className="mb-15 cover_container">
                  <div
                    style={{
                      backgroundImage: `url(${
                        this.state.displayCoverPhoto || MyDefaultCoverPhoto
                      })`,
                    }}
                    className="banner-img-back"
                    alt=""
                  />
                  <label
                    htmlFor="cover_photo"
                    className="mt-15 text_small text_dark_bright_blue upload-photo"
                    style={{ cursor: "pointer", marginBottom: "3px" }}
                  >
                    {CONSTANT.UPLOAD_COVER_PHOTO}
                  </label>
                  <input
                    id="cover_photo"
                    style={{ display: "none" }}
                    name="displayCoverPhoto"
                    type="file"
                    accept=".png, .jpeg, .jpg"
                    onChange={this.handleCoverImageOnChange}
                  />
                  <TextTheme
                    className="text_small text_red"
                    message={this.state.coverPicError}
                  />
                </div>
                <div className="mb-15 photo_container">
                  <img
                    style={{
                      width: "110px",
                      height: "110px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                    src={this.state.displayPhoto || GroupDefault}
                  />
                  <label
                    htmlFor="group_upload"
                    className="text_small text_dark_bright_blue upload-photo"
                    style={{
                      cursor: "pointer",
                      marginBottom: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    {CONSTANT.UPLOAD_PHOTO}
                  </label>
                  <input
                    id="group_upload"
                    style={{ display: "none" }}
                    name="displayPhoto"
                    type="file"
                    accept=".png, .jpeg, .jpg"
                    onChange={this.handleImageOnChange}
                  />
                  <TextTheme
                    className="text_small text_red"
                    message={this.state.profilePicError}
                  />
                </div>
              </div>
              <div className="mt-15 mb-15 group_name_field">
                <h4 className="aboutMeTitle">{CONSTANT.GROUP_NAME}</h4>
                <CustomInput
                  name={"groupName"}
                  value={this.state.groupName}
                  placeholder={CONSTANT.WHATS_YOUR_GROUP_NAME}
                  handleChange={this.handleDataChange}
                  error={
                    this.state.hasGroupName ? "" : CONSTANT.EMPTY_GROUP_NAME
                  }
                />
              </div>
              <div className="mb-15 contact_location_container">
                <div className="location_container">
                  <h4 className="aboutMeTitle">{CONSTANT.CONTACT_INFO}</h4>
                  <div className="location_field_container">
                    <TextTheme
                      message={CONSTANT.MOBILE + "*"}
                      className="text_small"
                    />
                    <CustomInput
                      name={"phone"}
                      value={this.state.phone}
                      placeholder={CONSTANT.MOBILE}
                      handleChange={this.handleDataChange}
                      error={
                        this.state.isPhoneValid
                          ? ""
                          : "Please enter a valid mobile number in a 10-digit format without symbols: xxxxxxxxxx"
                      }
                    />
                  </div>
                  <div className="location_field_container">
                    <TextTheme
                      message={CONSTANT.EMAIL + "*"}
                      className="text_small"
                    />
                    <CustomInput
                      name={"email"}
                      value={this.state.email}
                      placeholder={CONSTANT.EMAIL_PLACEHOLDER}
                      handleChange={this.handleDataChange}
                      error={
                        this.state.isEmailValid ? "" : CONSTANT.INVALID_EMAIL
                      }
                      type="email"
                      required
                    />
                  </div>
                  <div className="location_field_container">
                    <TextTheme
                      message={CONSTANT.WEBSITE}
                      className="text_small"
                    />
                    <CustomInput
                      name={"website"}
                      value={this.state.website}
                      placeholder={CONSTANT.WEBSITE_PLACEHOLDER}
                      handleChange={this.handleDataChange}
                      type="website"
                    />
                  </div>
                </div>
                <div className="location_container">
                  <h4 className="aboutMeTitle">{CONSTANT.LOCATION}</h4>
                  <div className="location_field_container">
                    <TextTheme
                      message={CONSTANT.STREET}
                      className="text_small"
                    />
                    <CustomInput
                      name={"street"}
                      value={this.state.street}
                      placeholder={CONSTANT.STREET_PLACEHOLDER}
                      handleChange={this.handleDataChange}
                    />
                  </div>
                  <div className="location_field_container">
                    <TextTheme message={CONSTANT.CITY} className="text_small" />
                    <CustomInput
                      name={"city"}
                      value={this.state.city}
                      placeholder={CONSTANT.CITY}
                      handleChange={this.handleDataChange}
                    />
                  </div>
                  <div className="zip_state_container">
                    <div className="location_field_container">
                      <TextTheme
                        message={CONSTANT.STATE}
                        className="text_small"
                      />
                      <div>
                        <CustomSelect
                          name={"stateUS"}
                          value={this.state.stateUS}
                          placeholder={CONSTANT.STATE}
                          handleChange={this.handleDataChange}
                          options={CONSTANT.US_STATES}
                        />
                      </div>
                    </div>
                    <div className="location_field_container">
                      <TextTheme
                        message={CONSTANT.ZIP}
                        className="text_small"
                      />
                      <CustomInput
                        name={"zip"}
                        value={this.state.zip}
                        placeholder={CONSTANT.ZIP_PLACEHOLDER}
                        handleChange={this.handleDataChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="groups_description_fields">
                <div className="mb-15 about_us">
                  <h4 className="aboutMeTitle">{CONSTANT.ABOUT_US}</h4>
                  <TextArea
                    name={"aboutUs"}
                    value={this.state.aboutUs}
                    placeholder={CONSTANT.ADD_GROUP_DESCRIPTION}
                    rows={4}
                    textClassName={"none"}
                    handleChange={this.handleDataChange}
                  />
                </div>
                <div className="mb-15 group_mission">
                  <h4 className="aboutMeTitle">{CONSTANT.GROUP_MISSION}</h4>
                  <TextArea
                    name={"groupMission"}
                    value={this.state.groupMission}
                    placeholder={CONSTANT.GROUP_MISSION_PLACEHOLDER}
                    rows={4}
                    textClassName={"none"}
                    handleChange={this.handleDataChange}
                  />
                </div>
                <div className="mb-15 we_support">
                  <GroupProjectCategoryGrid
                    projectCat={this.state.projectCat}
                    handleChange={ProfileHelper.onProjectInterestDataChange.bind(
                      this
                    )}
                    selectedOptions={this.state.projectInterest}
                  />
                </div>
                <div className="mb-15 favorite_causes">
                  <h4 className="aboutMeTitle">
                    {CONSTANT.GROUP_FAVORITE_CAUSES}
                  </h4>
                  <TextArea
                    name={"ourFavoriteCauses"}
                    value={this.state.ourFavoriteCauses}
                    placeholder={CONSTANT.GROUP_SUPPORT_PLACEHOLDER}
                    rows={4}
                    textClassName={"none"}
                    handleChange={this.handleDataChange}
                  />
                </div>
                {this.state.groupId == undefined ? (
                  <Fragment>
                    <h4 className="aboutMeTitle">
                      {CONSTANT.GROUP_VISIBILITY}
                    </h4>
                    <CustomVisibilityRadioButton
                      name={"visibility"}
                      handleChange={this.handleDataChange}
                      visibility={this.state.visibility}
                      isGroup={true}
                    />
                  </Fragment>
                ) : null}
                <div className="done_button_columns">
                  <TextTheme
                    message={CONSTANT.REQUIRED_FIELD}
                    className="text_xsmall text_light_med_grey"
                  />
                  <div className="text-right">
                    <RoundedButton
                      title={CONSTANT.DONE}
                      textThemeClassName="text_medium text_white text_bold"
                      buttonClassName="background_dark_orange"
                      style={{ margin: "0px" }}
                      handleOnClick={this.onSubmit}
                      borderRadius="6px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br /> <br />
          </div>
        </div>
      </div>
    );
  }
}

export default GroupForm;
